import { useAccountOptionsForApplicationAccountUser } from './useAccountOptionsForApplicationAccountUser'
import { ApplicationWithUserAccess } from './useManageApplicationAccountUser'

export function useApplicationAccountUserLimit(
  userApplication: ApplicationWithUserAccess,
) {
  const { AVAILABLE_ACCOUNT_OPTIONS } =
    useAccountOptionsForApplicationAccountUser(userApplication)

  const canAddMoreAccesses = userApplication.application.requiresEntityAccount
    ? AVAILABLE_ACCOUNT_OPTIONS.length > 0
    : userApplication.access.length === 0

  return { canAddMoreAccesses }
}
